import React from "react";
import { Link } from "react-router-dom";

// A link to a homepage section (#selected-work, #about, #contact) from any
// page. It goes through the router rather than a native hash jump: App.js
// scrolls to and focuses the section when the entry carries `reveal`, and a
// native jump would create a history entry the router's scroll restoration
// does not know about. The href stays a real "/#section" for new tabs.
function SectionLink({ section, children, ...rest }) {
  return (
    <Link to={{ pathname: "/", hash: `#${section}` }} state={{ reveal: true }} {...rest}>
      {children}
    </Link>
  );
}

// DS button markup on a link, for actions that navigate rather than act. The
// classes are the ones the DS Button renders, so the button tokens apply.
export function buttonLinkClass(variant = "primary", size = "medium") {
  return [
    "gds-button inline-flex items-center justify-center cursor-pointer select-none no-underline relative box-border",
    "gds-interaction gds-interaction--standard gds-button--cta",
    `gds-button--${variant} gds-button--${size}`,
  ].join(" ");
}

export const BUTTON_TEXT_CLASS = {
  small: "gds-button__text whitespace-nowrap body-sm-medium",
  medium: "gds-button__text whitespace-nowrap body-md-medium",
};

export default SectionLink;
